/*
 * Author: PMS
 * Title: D1 Form: Medicine list fetcher hook
 * Description: Binds the axiosPrivate instance and category URL to the shared
 *              getMedicineList cache/dedupe so tables and the background
 *              warm-up loop never fetch the same category twice. Optional
 *              month/year params are forwarded to the API; when both are
 *              present they select that month's stock data, otherwise the
 *              backend defaults to the current month/year.
 * Date: 16/08/2026
 */

import { useCallback } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import UrlService from '../../../services/UrlService';
import { getMedicineList } from './medicineListCache';

const useMedicineList = () => {
    const axiosPrivate = useAxiosPrivate();

    const fetcher = useCallback(
        (id, params) => {
            const base = UrlService.getMedicineListByIdUrl(id);
            const url =
                params?.month && params?.year
                    ? `${base}?month=${params.month}&year=${params.year}`
                    : base;
            return axiosPrivate
                .get(url, {
                    headers: { 'Content-Type': 'application/json' },
                })
                .then((response) => response?.data?.medicine_list);
        },
        [axiosPrivate]
    );

    return useCallback(
        (id, params) => getMedicineList(id, fetcher, params),
        [fetcher]
    );
};

export default useMedicineList;
